/* eslint-disable @typescript-eslint/camelcase */
import { CustomLabelsState, TermsAndConditionsType } from '../types';

const en: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'This space should contain the relevant information for the stakeholders regarding the usage of the portal.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Grievances portal',
    homePageText:
        '<p>Welcome to the grievances portal.</p>		<p>Using this secure and confidential platform, you can send us your grievance, request for information or suggestion, anonymously or not. You can then follow up on your concern.</p>		<p>Whether you choose to submit a complaint anonymously or not, rest assured that each submission will be treated confidentially and promptly.</p>',
    createGrievanceTitle: 'File a grievance',
    createGrievanceText:
        'Please enter the details of your concern. Be as specific as possible. If applicable, include the following: date, location, important details, and people involved. Add photos if you have any. If you would like to receive a follow-up, please provide your contact details in the appropriate section.',
    footerText:
        'If you prefer to talk to someone for any reason, you can call us at 819-555-5555. The opening hours are the following:<br/>			Monday to Friday from 8 AM to 5 PM, Eastern time zone (Montreal)<br/>			Outside these hours you can leave a message and someone will contact you.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo: 'Use this field only if you require clarification or support for your request',
    accessGrievanceBtn: 'Access a grievance',
    accessGrievanceTitle: 'Access a grievance',
    accessGrievanceInfo: 'Please enter your grievance number and password to follow up.',
    grievanceRefNo: 'Grievance number',
    originalGrievance: 'Original grievance',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Enter your grievance number...',
    forgotPasswordGrievanceText:
        'Please enter your grievance number and email address\n        that was used during creation. If you have created your\n        grievance anonymously or did not provide your email\n        address, please contact our customer service.',
    grievanceDescriptionPlaceholder: 'Grievance details...',
    detailsPlaceholder: 'Details...',
    grievanceConfirmSuccessText: 'Your grievance was successfully submitted.',
    grievanceConfirmInfoText: 'If you want to follow up on the grievance you just sent, please create a password',
    grievanceConfirmSubmitPasswordSuccessText:
        'Your password was successfully created, to follow up on your grievance go to the verify page',
    grievanceConfirmFollowUp: 'Follow up on grievance',
    viewInitialGrievance: 'View initial grievance',
    viewGrievance: 'View grievance',
    claimant: 'Claimant',
    emailNoteText: 'Your email address will be used to send automatic notifications but will not be seen by anyone.',
};

const fr: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        "Cet espace devrait contenir les informations pertinentes pour les parties prenantes concernant l'utilisation du portail.",
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portail de plaintes',
    homePageText:
        '<p>Bienvenue sur le portail des plaintes.</p>\n\t\t<p>À l’aide de cette plateforme sécuritaire et confidentielle, vous pouvez nous transmettre votre plainte, demande d’information ou suggestion, et ce, de façon anonyme ou non. Vous pourrez ensuite faire le suivi de votre préoccupation.</p>\n\t\t<p>Que vous choisissiez de soumettre une plainte de façon anonyme ou non, soyez assuré(e) que chaque soumission sera traitée de façon confidentielle et dans les meilleurs délais.</p>',
    createGrievanceTitle: 'Formuler une plainte',
    createGrievanceText:
        'Veuillez entrer les détails de votre plainte. Soyez le plus précis possible. S’il y a lieu, incluez le ou les éléments suivants : la date, les éléments importants, le lieu et les personnes impliquées. Ajoutez des photos si vous en avez. Si vous souhaitez recevoir un suivi, veuillez fournir vos coordonnées dans la section appropriée.',
    footerText:
        "Si vous préférez parler à quelqu'un, vous pouvez composer le 819-555-5555. Les heures d'ouverture sont:</br>\n\t\tLundi au vendredi de 8:00 à 17:00 heure de l'est (Montreal)</br>\n\t\tEn-dehors de ces heures vous pouvez laisser un message et quelqu'un vous contactera.",
    grievanceFollowUpAuthor: 'Système',
    addFollowUpModalInfo:
        "Utilisez ce champ uniquement si vous avez besoin d'éclaircissements ou de support pour votre demande",
    accessGrievanceTitle: 'Accéder à une plainte',
    grievanceRefNo: 'Numéro de la plainte',
    accessGrievanceInfo: 'Veuillez entrer votre numéro de plainte et votre mot de passe pour faire le suivi.',
    accessGrievanceBtn: 'Accéder à une plainte',
    viewGrievance: 'Voir la plainte',
    viewInitialGrievance: 'Voir la plainte initiale',
    originalGrievance: 'Plainte initiale',
    grievanceNumberPlaceholder: 'Entrez votre numéro de plainte...',
    grievanceDescriptionPlaceholder: 'Détail de la plainte...',
    detailsPlaceholder: 'Détails...',
    forgotPasswordGrievanceText:
        "Veuillez entrer votre numéro de plainte ainsi que l'adresse courriel\n         qui a été utilisée lors de la création. Si vous avez créé votre\n       plainte de façon anonyme ou n'avez pas fourni votre adresse\n      courriel, veuillez contacter notre service à la clientèle.",
    grievanceConfirmSuccessText: 'Votre plainte a été soumise avec succès.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Votre mot de passe a été créé avec succès, pour donner suite à votre demande, allez sur la page de vérification',
    grievanceConfirmFollowUp: 'Faire un suivi de la plainte',
    grievanceConfirmInfoText:
        "Si vous souhaitez donner suite à la plainte que vous venez d'envoyer, veuillez créer un mot de passe",
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Demandeur',
    emailNoteText:
        'Votre adresse courriel sera utilisée pour envoyer des notifications automatiques mais ne sera vue par personne.',
};

const es: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Este espacio debe contener la información relevante para las partes interesadas con respecto al uso del portal.',

    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal de quejas',

    homePageText:
        '<p>Bienvenido al portal de quejas</p>\n\t\t<p>Usando esta plataforma segura y confidencial, puede enviarnos su queja, solicitud de información o sugerencia, ya sea de forma anónima o no. Luego, puede hacer un seguimiento de su inquietud.</p>\n\t\t<p>Ya sea que envíe una queja de forma anónima o no, tenga la seguridad de que cada solicitud se tratará de forma confidencial y rápida.</p>',
    createGrievanceTitle: 'Ingresar una solicitud',
    createGrievanceText:
        'Ingrese los detalles de su solicitud. Sea lo más específico posible. Incluya el(los) siguiente(s) elemento(s): fecha, elementos importantes, ubicación y personas involucradas. Agregue fotos si tiene alguna. Si desea recibir un seguimiento, proporcione sus datos de contacto en la sección correspondiente.',
    footerText:
        'Si prefiere hablar con alguno de nuestros representantes, puede llamarnos al 819-555-5555. Los horarios de atención son los siguientes:<br/>\n\t\t\tLunes a viernes de 8 a.m. a 5 p.m., Zona horaria del este (Montreal) <br/>\n\t\t\tFuera de ese horario puede dejar un mensaje y nos pondremos en contacto con usted lo antes posible.',
    grievanceFollowUpAuthor: 'Sistema',
    addFollowUpModalInfo:
        'Utilizar este campo sólo si requiere realizar aclaraciones o nuevos soportes para su solicitud',
    accessGrievanceTitle: 'Acceder a una solicitud',
    grievanceRefNo: 'Número de solicitud',
    accessGrievanceInfo: 'Ingrese su número de solicitud y contraseña para realizar el seguimiento.',
    accessGrievanceBtn: 'Acceder a una solicitud',
    viewGrievance: 'Ver solicitud',
    viewInitialGrievance: 'Ver solicitud inicial',
    originalGrievance: 'Solicitud original',
    grievanceNumberPlaceholder: 'Ingrese el número de solicitud...',
    grievanceDescriptionPlaceholder: 'Detalles de la solicitud...',
    detailsPlaceholder: 'Detalles...',
    forgotPasswordGrievanceText:
        'Por favor ingrese su número de solicitud y dirección de correo electrónico usados durante la creación.\n        Si ha creado la solicitud de forma anónima o no proporcionó su dirección correo electrónico,\n        póngase en contacto con nuestro servicio al cliente.',
    grievanceConfirmSuccessText: 'Su solicitud se envió correctamente.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Su contraseña se creó correctamente, para seguir su solicitud, vaya a la página de verificación',
    grievanceConfirmFollowUp: 'Seguimiento a pedido',
    grievanceConfirmInfoText:
        'Si desea hacer un seguimiento a la solicitud que acaba de enviar, por favor cree una contraseña',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Solicitante',
    emailNoteText:
        'Su dirección de correo electrónico se utilizará para enviar notificaciones automáticas, pero nadie podrá verla.',
};

const pt: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Este espaço deve conter as informações relevantes para os stakeholders a respeito do uso do portal.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal de reclamações',
    homePageText:
        '<p> Bem-vindo(a) ao portal de reclamações.</p>		<p> Utilizando esta plataforma segura e confidencial, você pode nos enviar sua reclamação, dúvida ou sugestão, de forma anônima ou não. Em seguida, você pode acompanhar sua solicitação. p>		<p> Tenha certeza de que cada envio será tratado de forma confidencial e rápida, mesmo se você optar por enviar uma reclamação anonimamente ou não.</p>',
    createGrievanceTitle: 'Enviar uma reclamação',
    createGrievanceText:
        ' Por favor, insira os detalhes da sua reclamação. Seja o mais específico possível. Se aplicável, inclua as informações seguintes: data, local, detalhes importantes e pessoas envolvidas. Caso tenha alguma(s) foto(s), você também pode adicioná-la(s). Se você deseja receber um acompanhamento da sua reclamação, forneça seus detalhes de contato na seção apropriada.',
    footerText:
        'Caso prefira falar com alguém por qualquer motivo, você pode nos ligar no +1 819-555-5555. O horário de funcionamento é o seguinte:<br/>			De segunda a sexta das 8h às 17h, horário de Montreal<br/>			Fora desse horário você pode nos deixar uma mensagem e alguém entrará em contato com você.',
    grievanceFollowUpAuthor: 'Sistema',
    addFollowUpModalInfo: 'Use este campo apenas se você precisar de esclarecimentos ou suporte para sua solicitação',
    accessGrievanceBtn: 'Acessar uma reclamação',
    accessGrievanceTitle: 'Acessar uma reclamação',
    accessGrievanceInfo: ' Por favor, insira o número da reclamação e a sua senha para acompanhar a sua solicitação.',
    grievanceRefNo: 'Número da reclamação',
    originalGrievance: 'Reclamação original',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Digite o número da sua reclamação...',
    forgotPasswordGrievanceText:
        ' Digite o número da reclamação e o endereço de e-mail \n        que foi usado durante a criação da sua reclamação. Se você criou a sua \n        reclamação anonimamente ou não forneceu seu endereço de \n        e-mail, entre em contato com o nosso serviço ao cliente.',
    grievanceDescriptionPlaceholder: 'Detalhes da reclamação...',
    detailsPlaceholder: 'Detalhes...',
    grievanceConfirmSuccessText: 'Sua reclamação foi enviada com sucesso.',
    grievanceConfirmInfoText: 'Se você deseja acompanhar a reclamação que acabou de enviar, crie uma senha',
    grievanceConfirmSubmitPasswordSuccessText:
        'Sua senha foi criada com sucesso. Para acompanhar sua reclamação vá para a página de verificação',
    grievanceConfirmFollowUp: 'Acompanhar reclamação',
    viewInitialGrievance: 'Ver reclamação inicial',
    viewGrievance: 'Ver reclamação',
    claimant: 'Requerente',
    emailNoteText:
        'Seu endereço de e-mail será usado para envio de notificações automáticas, mas não será visto por ninguém.',
};

const ar: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'يجب أن تحتوي هذه المساحة على المعلومات ذات الصلة لأصحاب المصلحة فيما يتعلق باستخدام البوابة.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'بوابة الشكاوى',
    homePageText:
        '<p> مرحبا بك في بوابة الشكاوى.</p>		<p> باستخدام هذا النظام الأساسي الآمن والسري ، يمكنك إرسال شكواك إلينا أو طلب معلومات أو اقتراح ، سواء أكان ذلك مجهولاً أم لا. يمكنك بعد ذلك متابعة ما يقلقك.</p>		<p> سواء اخترت تقديم شكوى دون الكشف عن هويتك أم لا ، كن مطمئنًا إلى أن كل إرسال سيتم التعامل معه بسرية وفورية.</p>',
    createGrievanceTitle: 'قدم شكوى',
    createGrievanceText:
        ' الرجاء إدخال تفاصيل قلقك. أن تكون محددة قدر الإمكان. إن أمكن ، قم بتضمين ما يلي: التاريخ والموقع والتفاصيل المهمة والأشخاص المعنيين. أضف الصور إذا كان لديك أي منها. إذا كنت ترغب في تلقي متابعة ، يرجى تقديم تفاصيل الاتصال الخاصة بك في القسم المناسب.',
    footerText:
        'إذا كنت تفضل التحدث إلى شخص ما لأي سبب ، يمكنك الاتصال بنا على 5555-555-819. ساعات العمل هي كما يلي:<br/>			من الاثنين إلى الجمعة من الساعة 8 صباحًا حتى 5 مساءً ، المنطقة الزمنية الشرقية (مونتريال)<br/>			خارج هذه الساعات يمكنك ترك رسالة وسيتصل بك شخص ما.',
    grievanceFollowUpAuthor: ' نظام',
    addFollowUpModalInfo: 'استخدم هذا الحقل فقط إذا كنت تحتاج إلى توضيح أو دعم لطلبك',
    accessGrievanceBtn: 'الوصول إلى شكوى',
    accessGrievanceTitle: 'الوصول إلى شكوى',
    accessGrievanceInfo: ' الرجاء إدخال رقم الشكوى وكلمة المرور للمتابعة.',
    grievanceRefNo: 'رقم الشكوى ',
    originalGrievance: 'الشكوى الأصلية',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'أدخل رقم شكواك ...',
    forgotPasswordGrievanceText:
        'الرجاء إدخال رقم الشكوى وعنوان البريد الإلكتروني الخاص بك \n        التي تم استخدامها أثناء الإنشاء. إذا قمت بإنشاء ملف \n        شكوى مجهولة أو لم تقدم عنوانك \n        البريد الإلكتروني ، يرجى الاتصال بخدمة العملاء.',
    grievanceDescriptionPlaceholder: 'تفاصيل الشكوى ...',
    detailsPlaceholder: 'تفاصيل...',
    grievanceConfirmSuccessText: 'تم تقديم شكواك بنجاح.',
    grievanceConfirmInfoText: ' إذا كنت ترغب في متابعة الشكوى التي أرسلتها للتو ، يرجى إنشاء كلمة مرور',
    grievanceConfirmSubmitPasswordSuccessText:
        'تم إنشاء كلمة المرور الخاصة بك بنجاح ، لمتابعة شكواك ، انتقل إلى صفحة التحقق',
    grievanceConfirmFollowUp: 'متابعة الشكوى',
    viewInitialGrievance: 'عرض الشكوى الأولية',
    viewGrievance: 'عرض الشكوى',
    claimant: ' المدعي ',
    emailNoteText: 'سيتم استخدام عنوان بريدك الإلكتروني لإرسال إشعارات تلقائية ولكن لن يراه أحد.',
};

const fi: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText: 'Tämän tilan olisi sisällettävä sidosryhmille tärkeitä tietoja portaalin käytöstä.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Kantelujen portaali',
    homePageText:
        '<p>Tervetuloa kanteluportaaliin.</p>		<p>Tämän suojatun ja luottamuksellisen foorumin kautta voit lähettää meille valituksesi, tietopyyntösi tai ehdotuksesi nimettömänä tai ilman. Voit sitten seurata huolenaiheesi käsittelyä.</p>		<p>Riippumatta siitä, haluatko tehdä valituksen nimettömänä vai et, voit olla varma, että jokainen valitus käsitellään luottamuksellisesti ja viipymättä.</p>',
    createGrievanceTitle: 'Tee valitus',
    createGrievanceText:
        'Kirjoita huolenaiheesi yksityiskohdat. Ole mahdollisimman tarkka.Ilmoita tarvittaessa seuraavat tiedot: päivämäärä, paikka, tärkeät yksityiskohdat ja osallistuneet henkilöt. Lisää valokuvia, jos sinulla on sellaisia. Jos haluat saada jatkotoimia, anna yhteystietosi asianmukaiseen kohtaan.',
    footerText:
        'Jos haluat jostain syystä puhua jonkun kanssa, voit soittaa meille numeroon 819-555-5555. Aukioloajat ovat seuraavat:<br/>			Maanantaista perjantaihin klo 8-17, itäinen aikavyöhyke (Montreal).<br/>			Näiden aikojen ulkopuolella voit jättää viestin ja joku ottaa sinuun yhteyttä.',
    grievanceFollowUpAuthor: 'Järjestelmä',
    addFollowUpModalInfo: 'Käytä tätä kenttää vain, jos tarvitset selvennystä tai tukea pyyntöösi.',
    accessGrievanceBtn: 'Pääsy kanteluun',
    accessGrievanceTitle: 'Pääsy kanteluun',
    accessGrievanceInfo: 'Kirjoita valituksen numero ja salasana jatkotoimia varten.',
    grievanceRefNo: 'Palautteen numero',
    originalGrievance: 'Alkuperäinen kantelu',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Syötä valituksesi numero...',
    forgotPasswordGrievanceText:
        'Anna valituksen numero ja sähköpostiosoite.\n        jota käytettiin luomisen aikana. Jos olet luonut\n        valituksen nimettömänä tai et ole antanut osoitettasi\n        sähköpostiosoitetta, ota yhteyttä asiakaspalveluumme.',
    grievanceDescriptionPlaceholder: 'Valituksen yksityiskohdat...',
    detailsPlaceholder: 'Yksityiskohdat...',
    grievanceConfirmSuccessText: 'Kantelusi on toimitettu onnistuneesti.',
    grievanceConfirmInfoText: 'Jos haluat seurata juuri lähettämääsi valitusta, luo salasana.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Salasanasi luotiin onnistuneesti, voit seurata valitustasi siirtyäksesi vahvistussivulle',
    grievanceConfirmFollowUp: 'Valituksen seuranta',
    viewInitialGrievance: 'Alkuperäisen valituksen tarkastelu',
    viewGrievance: 'Näytä valitus',
    claimant: 'Hakija',
    emailNoteText: 'Sähköpostiin lähetetään ainoastaan automaattisia ilmoituksia. Kukaan ei näe sähköpostiosoitetta.',
};

const sv: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Detta utrymme bör innehålla relevant information för intressenterna om hur portalen används.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal för klagomål',
    homePageText:
        '<p>Välkommen till portalen för klagomål.</p>		<p>Via denna säkra och konfidentiella plattform kan du skicka oss ditt klagomål, din begäran om information eller ditt förslag, anonymt eller inte. Du kan sedan följa upp ditt ärende.</p>		<p>Oavsett om du väljer att lämna in ett klagomål anonymt eller inte kan du vara säker på att varje klagomål behandlas konfidentiellt och snabbt.</p>',
    createGrievanceTitle: 'Lämna in ett klagomål',
    createGrievanceText:
        'Ange detaljerna om ditt ärende. Var så specifik som möjligt. Ange i förekommande fall följande: datum, plats, viktiga uppgifter och berörda personer. Lägg till foton om du har några. Om du vill få en uppföljning, vänligen ange dina kontaktuppgifter i det aktuella avsnittet.',
    footerText:
        'Om du föredrar att prata med någon av någon anledning kan du ringa oss på 819-555-5555. Öppettiderna är följande:<br/>			Måndag till fredag kl. 8-17, östlig tidszon (Montreal)<br/>			Utanför dessa tider kan du lämna ett meddelande och någon kommer att kontakta dig.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo: 'Använd det här fältet endast om du behöver ett förtydligande eller stöd för din begäran.',
    accessGrievanceBtn: 'Få tillgång till ett klagomål',
    accessGrievanceTitle: 'Få tillgång till ett klagomål',
    accessGrievanceInfo: 'Ange ditt klagomålsnummer och lösenord för att följa upp det.',
    grievanceRefNo: 'Ärendenummer',
    originalGrievance: 'Ursprungligt klagomål',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Ange ditt klagomålsnummer...',
    forgotPasswordGrievanceText:
        ' Ange ditt klagomålsnummer och din e-postadress\n             som användes vid skapandet. Om du har skapat din\n            klagomål anonymt eller om du inte har angett din adress\n         e-postadress, vänligen kontakta vår kundtjänst.',
    grievanceDescriptionPlaceholder: 'Uppgifter om klagomål...',
    detailsPlaceholder: 'Detaljer...',
    grievanceConfirmSuccessText: 'Ditt klagomål har skickats in',
    grievanceConfirmInfoText: 'Om du vill följa upp det klagomål som du just skickade, skapa ett lösenord',
    grievanceConfirmSubmitPasswordSuccessText:
        'Ditt lösenord har skapats, för att följa upp ditt klagomål går du till sidan Verifiera',
    grievanceConfirmFollowUp: 'Uppföljning av klagomål',
    viewInitialGrievance: 'Visa det ursprungliga klagomålet',
    viewGrievance: 'Visa klagomål',
    claimant: 'Sökande',
    emailNoteText:
        'Din epostadress kommer att användas för att skicka automatiska notifieringar. Din epostadress kan ej läsas av någon annan.',
};

const ja: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText: 'このスペースには、ポータルの利用方法に関する利害関係者のための関連情報を記載する。',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: '苦情処理ポータル',
    homePageText:
        '<p>苦情処理ポータルへようこそ。</p>		<p>この安全で機密性の高いプラットフォームを使用すると、匿名かどうかにかかわらず、苦情、情報要求、または提案を送ることができます。その後、あなたの懸念についてフォローアップすることができます。</p>		<p>匿名で苦情を提出するかどうかにかかわらず、提出された苦情は機密扱いで迅速に処理されますのでご安心ください。</p>',
    createGrievanceTitle: '苦情を申し立てる',
    createGrievanceText:
        'お気づきの点を詳しくご記入ください。できるだけ具体的に記入してください。該当する場合は、日付、場所、重要な内容、関係者などを記入してください。写真があれば追加してください。フォローアップを希望される場合は、該当する欄に連絡先をご記入ください。',
    footerText:
        'お電話でのお問い合わせは、819-555-5555までご連絡ください。営業時間は以下の通りです：<br/>			月～金：午前8時～午後5時、東部時間帯（モントリオール）<br/>			時間外でもメッセージを残していただければ、担当者がご連絡いたします。',
    grievanceFollowUpAuthor: 'システム',
    addFollowUpModalInfo: 'このフィールドは、リクエストに関する説明やサポートが必要な場合にのみ使用してください。',
    accessGrievanceBtn: '苦情処理へのアクセス',
    accessGrievanceTitle: '苦情処理へのアクセス',
    accessGrievanceInfo: '苦情処理番号とパスワードを入力してください。',
    grievanceRefNo: '苦情処理番号',
    originalGrievance: '元の苦情',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: '苦情処理番号を入力してください。',
    forgotPasswordGrievanceText:
        '苦情処理番号とEメールアドレスを入力してください。\n        作成時に使用されたものです。もし\n        匿名で苦情を申し立てた場合、または電子メールを提供しなかった場合\n        の住所までご連絡ください。',
    grievanceDescriptionPlaceholder: '苦情の詳細...',
    detailsPlaceholder: '詳細...',
    grievanceConfirmSuccessText: '苦情は正常に提出されました。',
    grievanceConfirmInfoText: '送信した苦情に対するフォローアップを希望される場合は、パスワードを作成してください。',
    grievanceConfirmSubmitPasswordSuccessText:
        'パスワードが正常に作成されました。苦情のフォローアップを行うには、確認ページに移動してください。',
    grievanceConfirmFollowUp: '苦情のフォローアップ',
    viewInitialGrievance: '最初の苦情を見る',
    viewGrievance: '苦情を表示',
    claimant: 'クレーム主',
    emailNoteText: 'あなたの電子メールアドレスは自動通知の送信に使用されますが、誰にも見られません。',
};

const de: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Dieser Bereich sollte die relevanten Informationen für die Teilnehmer über die Nutzung des Portals enthalten.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal für Beschwerden',
    homePageText:
        '<p>Willkommen im Beschwerdeportal.</p>		<p>Über diese sichere und vertrauliche Plattform können Sie uns Ihre Beschwerde, Ihr Ersuchen um Informationen oder Ihre Anregungen übermitteln - anonym oder nicht. Sie können Ihr Anliegen dann weiterverfolgen.</p>		<p>Unabhängig davon, ob Sie eine Beschwerde anonym einreichen oder nicht, können Sie sicher sein, dass jede Beschwerde vertraulich und umgehend behandelt wird.</p>',
    createGrievanceTitle: 'Beschwerde einreichen',
    createGrievanceText:
        'Bitte geben Sie die Details zu Ihren Bedenken an. Seien Sie so genau wie möglich. Geben Sie alle betreffenden Daten, Orte, wichtige Details und Namen der beteiligten Personen an. Fügen Sie bei Bedarf Fotos hinzu. Wenn Sie weitere Informationen erhalten möchten, tragen Sie bitte Ihre Kontaktdaten in den entsprechenden Abschnitt ein.',
    footerText:
        'Wenn Sie lieber mit einem Vertreter sprechen möchten, rufen Sie 819-555-5555 an. Unsere Geschäftszeiten sind <br/>			Montag bis Freitag von 8 Uhr bis 17 Uhr Eastern Time (Montreal).<br/>			Außerhalb dieser Zeiten können Sie eine Nachricht hinterlassen und jemand wird Sie zurückrufen.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo:
        'Verwenden Sie dieses Feld nur, wenn Sie Klärung oder Unterstützung im Zusammenhang mit Ihrer Anfrage benötigen',
    accessGrievanceBtn: 'Beschwerdezugriff',
    accessGrievanceTitle: 'Beschwerdezugriff',
    accessGrievanceInfo:
        'Bitte geben Sie Ihre Beschwerde-Nummer und Ihr Passwort ein, um die Beschwerde zu bearbeiten.',
    grievanceRefNo: 'Beschwerde Nummer',
    originalGrievance: 'Ursprüngliche Beschwerde',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Geben Sie Ihre Beschwerdenummer ein...',
    forgotPasswordGrievanceText:
        'Bitte geben Sie Ihre Beschwerde-Nummer und E-Mail-Adresse ein\n        die während der Erstellung benutzt wurde. If you have created your\n        beschwerde anonymously or have not provided your e-mail\n        address, please contact our customer service.',
    grievanceDescriptionPlaceholder: 'Details zur Beschwerde...',
    detailsPlaceholder: 'Einzelheiten...',
    grievanceConfirmSuccessText: 'Ihre Beschwerde wurde erfolgreich eingereicht.',
    grievanceConfirmInfoText:
        'Wenn Sie die soeben abgeschickte Beschwerde verfolgen möchten, erstellen Sie bitte ein Passwort',
    grievanceConfirmSubmitPasswordSuccessText:
        'Ihr Passwort wurde erfolgreich erstellt. Um Ihre Beschwerde zu verfolgen, gehen Sie auf die Bestätigungsseite',
    grievanceConfirmFollowUp: 'Weiterverfolgung der Beschwerde',
    viewInitialGrievance: 'Erste Beschwerde anzeigen',
    viewGrievance: 'Beschwerde ansehen',
    claimant: 'Antragsteller',
    emailNoteText:
        'Ihre E-Mail-Adresse wird für den Versand von automatischen Benachrichtigungen verwendet, aber niemand wird sie sehen.',
};
const ru: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText: 'Этот раздел должен содержать информацию для участников о том, как использовать портал.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Портал жалоб',
    homePageText:
        '<p>Добро пожаловать на портал жалоб.</p>		<p>Через эту безопасную и конфиденциальную платформу вы можете отправить нам свою жалобу, запрос информации или предложения - анонимно или нет. Вы сможете отслеживать свое обращение.</p>		<p>Независимо от того, отправляете ли вы жалобу анонимно или нет, вы можете быть уверены, что каждая жалоба будет рассмотрена конфиденциально и незамедлительно.</p>',
    createGrievanceTitle: 'Подать жалобу',
    createGrievanceText:
        'Пожалуйста, укажите детали вашей проблемы. Будьте максимально точны. Укажите все соответствующие данные, места, важные детали и имена участвующих лиц. При необходимости добавьте фотографии. Если вы хотите получить дополнительную информацию, пожалуйста, укажите свои контактные данные в соответствующем разделе.',
    footerText:
        'Если вы предпочитаете общаться с представителем, позвоните по номеру 819-555-5555. Наши часы работы: <br/>			понедельник - пятница с 8:00 до 17:00 по восточному времени (Монреаль).<br/>			В нерабочее время вы можете оставить сообщение, и вам перезвонят.',
    grievanceFollowUpAuthor: 'Систем',
    addFollowUpModalInfo:
        'Используйте это поле только в случае необходимости уточнения или поддержки по вашему запросу',
    accessGrievanceBtn: 'Доступ к жалобе',
    accessGrievanceTitle: 'Доступ к жалобе',
    accessGrievanceInfo: 'Пожалуйста, введите номер вашей жалобы и пароль, чтобы редактировать жалобу.',
    grievanceRefNo: 'Номер жалобы',
    originalGrievance: 'Исходная жалоба',
    grievanceRefNoFormat: 'GR-00000',
    forgotPasswordGrievanceText:
        'Пожалуйста, введите номер вашего жалобы и адрес электронной почты, \n        который использовался при создании. Если вы создали свою \n        жалобу анонимно или не предоставили свой адрес электронной \n        почты, пожалуйста, свяжитесь с нашим отделом обслуживания клиентов.',
    grievanceNumberPlaceholder: 'Введите номер вашей жалобы...',
    grievanceDescriptionPlaceholder: 'Детали жалобы...',
    detailsPlaceholder: 'Детали...',
    grievanceConfirmSuccessText: 'Ваша жалоба успешно отправлена.',
    grievanceConfirmInfoText: 'Если вы хотите отслеживать только что отправленную жалобу, создайте пароль',
    grievanceConfirmSubmitPasswordSuccessText:
        'Ваш пароль успешно создан. Чтобы отслеживать вашу жалобу, перейдите на страницу подтверждения',
    grievanceConfirmFollowUp: 'Последующие действия в связи с жалобой',
    viewInitialGrievance: 'Просмотреть первоначальную жалобу',
    viewGrievance: 'Просмотреть жалобу',
    claimant: 'Заявитель',
    emailNoteText:
        'Ваш адрес электронной почты будет использоваться для отправки автоматических уведомлений, но не будет виден никому.',
};

const uz: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        "Ushbu bo'shliq manfaatdor tomonlar uchun portalni ishlatish haqidagi tegishli ma'lumotlarni o'z ichiga olishi kerak.",
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Shikoyatlar portali',
    homePageText:
        '<p>Shikoyatlar portaliga xush kelibsiz.</p>\n\t\t<p>Ushbu xavfsiz va maxfiy platformadan foydalanib, siz bizga shikoyatingizni, ma’lumot so’rovini yoki taklifingizni anonim yoki anonim bo’lmagan tarzda yuborishingiz mumkin. Keyin siz o’zingizning muammoingizni kuzatishingiz mumkin.</p>\n\t\t<p>Anonim yoki anonim bo’lmagan tarzda shikoyat yuborishni tanlasangiz ham, har bir topshiriq maxfiylik bilan va eng qisqa vaqt ichida ko’rib chiqilishini tasdiqlashingiz mumkin.</p>',
    createGrievanceTitle: 'Shikoyat qiling',
    createGrievanceText:
        'Iltimos, shikoyatingiz tafsilotlarini kiriting. Iltimos, imkon qadar aniq bo’ling. Agar mavjud bo’lsa, quyidagi elementlarni qo’shing: sana, muhim tafsilotlar, joy va ishtirokchilar. Agar mavjud bo’lsa, fotosuratlarni qo’shing. Agar siz kuzatib borishni xohlasangiz, tegishli bo’limda kontakt ma’lumotlaringizni taqdim eting.',
    footerText:
        "Agar kimdir bilan gaplashishni afzal ko'rsangiz, 819-555-5555 raqamiga qo'ng'iroq qilishingiz mumkin. Ish vaqti:</br>\n\t\tDushanbadan jumagacha soat 8:00 dan 17:00 gacha (Monreal vaqti bilan)</br>\n\t\tUshbu soatlar tashqarisida siz xabar qoldirishingiz mumkin va kimdir siz bilan bog'lanadi.",
    grievanceFollowUpAuthor: 'Tizim',
    addFollowUpModalInfo:
        "Ushbu maydondan faqat so'rovingiz uchun qo'shimcha ma'lumot yoki yordam kerak bo'lsa foydalaning",
    accessGrievanceTitle: 'Shikoyatga kirish',
    grievanceRefNo: 'Shikoyat raqami',
    accessGrievanceInfo: 'Iltimos, shikoyat raqamingizni va parolingizni kiriting.',
    accessGrievanceBtn: 'Shikoyatga kirish',
    viewGrievance: "Shikoyatni ko'rish",
    viewInitialGrievance: "Dastlabki shikoyatni ko'rish",
    originalGrievance: 'Dastlabki shikoyat',
    grievanceNumberPlaceholder: 'Shikoyat raqamingizni kiriting...',
    grievanceDescriptionPlaceholder: 'Shikoyat tafsilotlari...',
    detailsPlaceholder: 'Tafsilotlar...',
    forgotPasswordGrievanceText:
        "Iltimos, shikoyat raqamingiz va yaratishda foydalanilgan elektron pochta manzilingizni kiriting. \n        Agar siz shikoyatingizni anonim tarzda yaratgan bo'lsangiz yoki elektron pochta manzilingizni taqdim qilmagan bo'lsangiz, \n        mijozlarga xizmat ko'rsatish bo'limiga murojaat qiling.",
    grievanceConfirmSuccessText: 'Shikoyatingiz muvaffaqiyatli yuborildi.',
    grievanceConfirmSubmitPasswordSuccessText:
        "Parolingiz muvaffaqiyatli yaratildi, talabni davom ettirish uchun tasdiqlash sahifasiga o'ting",
    grievanceConfirmFollowUp: 'Shikoyatni kuzatish',
    grievanceConfirmInfoText: 'Yuborgan shikoyatingizga javob berishni istasangiz, iltimos parol yarating',
    grievanceRefNoFormat: 'GR-00000',
    claimant: "Da'vogar",
    emailNoteText:
        'Elektron pochta manzilingiz avtomatik bildirishnomalar yuborish uchun ishlatiladi, lekin hech kim ko`rmaydi.',
};

const el: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Αυτός ο χώρος πρέπει να περιλαμβάνει τις σχετικές πληροφορίες για τα ενδιαφερόμενα μέρη σχετικά με τη χρήση της πύλης.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Πύλη Καταγγελιών',
    homePageText:
        '<p>Καλώς ήρθατε στην πύλη καταγγελιών.</p>\n\t\t<p>Χρησιμοποιώντας αυτήν την ασφαλή και εμπιστευτική πλατφόρμα, μπορείτε να μας καταθέσετε την καταγγελία, το αίτημα πληροφοριών ή την πρότασή σας, είτε ανώνυμα είτε όχι. Στη συνέχεια, θα μπορέσετε να παρακολουθήσετε το θέμα σας.</p>\n\t\t<p>Ανεξάρτητα από το εάν επιλέξετε να καταθέσετε μια καταγγελία ανώνυμα ή όχι, να είστε βέβαιοι ότι κάθε υποβολή θα επεξεργαστεί με απόλυτη εμπιστευτικότητα και το συντομότερο δυνατόν.</p>',
    createGrievanceTitle: 'Υποβολή Καταγγελίας',
    createGrievanceText:
        'Παρακαλώ εισάγετε τα στοιχεία της καταγγελίας σας. Να είστε όσο το δυνατόν πιο ακριβείς. Εάν είναι εφικτό, συμπεριλάβετε τα ακόλουθα: η ημερομηνία, τα σημαντικά στοιχεία, ο τόπος και τα άτομα που εμπλέκονται. Προσθέστε φωτογραφίες αν έχετε. Εάν επιθυμείτε να λάβετε ανταπόκριση, παρακαλούμε παράσχετε τα στοιχεία επικοινωνίας σας στον κατάλληλο τομέα.',
    footerText:
        'Αν προτιμάτε να μιλήσετε με κάποιον, μπορείτε να καλέσετε το 819-555-5555. Οι ώρες λειτουργίας είναι:</br>\n\t\tΔευτέρα έως Παρασκευή από τις 8:00 έως τις 17:00 ώρα ανατολικής (Μόντρεαλ)</br>\n\t\tΕκτός αυτών των ωρών μπορείτε να αφήσετε ένα μήνυμα και κάποιος θα επικοινωνήσει μαζί σας.',
    grievanceFollowUpAuthor: 'Σύστημα',
    addFollowUpModalInfo:
        'Χρησιμοποιήστε αυτό το πεδίο μόνον εάν χρειάζεστε διευκρινίσεις ή υποστήριξη για το αίτημά σας',
    accessGrievanceTitle: 'Πρόσβαση σε καταγγελία',
    grievanceRefNo: 'Αριθμός Καταγγελίας',
    accessGrievanceInfo:
        'Παρακαλούμε εισάγετε τον αριθμό καταγγελίας σας και τον κωδικό πρόσβασής σας για να παρακολουθήσετε.',
    accessGrievanceBtn: 'Πρόσβαση σε καταγγελία',
    viewGrievance: 'Προβολή καταγγελίας',
    viewInitialGrievance: 'Προβολή αρχικής καταγγελίας',
    originalGrievance: 'Αρχική καταγγελία',
    grievanceNumberPlaceholder: 'Εισαγάγετε τον αριθμό της καταγγελίας σας...',
    grievanceDescriptionPlaceholder: 'Λεπτομέρειες καταγγελίας...',
    detailsPlaceholder: 'Λεπτομέρειες...',
    forgotPasswordGrievanceText:
        'Παρακαλώ εισάγετε τον αριθμό της καταγγελίας σας καθώς και τη διεύθυνση email\n που χρησιμοποιήθηκε κατά τη δημιουργία. Αν δημιουργήσατε την καταγγελία σας ανώνυμα ή δεν δώσατε τη διεύθυνση email σας, παρακαλώ επικοινωνήστε με την υπηρεσία πελατών μας.',
    grievanceConfirmSuccessText: 'Η καταγγελία σας υποβλήθηκε με επιτυχία.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Ο κωδικός πρόσβασής σας δημιουργήθηκε με επιτυχία, για να δώσετε συνέχεια στο αίτημά σας, μεταβείτε στη σελίδα επιβεβαίωσης',
    grievanceConfirmFollowUp: 'Ακολουθία καταγγελίας',
    grievanceConfirmInfoText:
        'Εάν θέλετε να δώσετε συνέχεια στην καταγγελία που μόλις υποβάλατε, παρακαλούμε δημιουργήστε έναν κωδικό πρόσβασης',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Καταγγέλλων',
    emailNoteText:
        'Το email σας θα χρησιμοποιηθεί για την αποστολή αυτόματων ειδοποιήσεων, αλλά δεν θα είναι ορατό από κανέναν.',
};

const sw: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText: 'Nafasi hii inapaswa kuwa na habari muhimu kwa wadau kuhusu matumizi ya lango.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Lango la Malalamiko',
    homePageText:
        '<p>Karibu kwenye lango la malalamiko.</p>\n\t\t<p>Kwa kutumia jukwaa hili salama na la siri, unaweza kutuletea malalamiko yako, ombi la habari au mapendekezo, kwa namna ya siri au wazi. Baadaye, utaweza kufuatilia wasiwasi wako.</p>\n\t\t<p>Iwe unachagua kuwasilisha malalamiko kwa njia ya siri au la, hakikisha kwamba kila usajili utashughulikiwa kwa siri na kwa wakati unaofaa.</p>',
    createGrievanceTitle: 'Kuwasilisha Malalamiko',
    createGrievanceText:
        'Tafadhali ingiza maelezo ya malalamiko yako. Kuwa sahihi iwezekanavyo. Ikiwa ni muhimu, jumuisha yafuatayo: tarehe, vipengele muhimu, mahali na watu waliohusika. Ongeza picha ikiwa una. Ikiwa unataka kupata ufuatiliaji, tafadhali toa maelezo yako ya mawasiliano kwenye sehemu inayofaa.',
    footerText:
        'Ikiwa unapendelea kuzungumza na mtu, unaweza kupiga simu kwa 819-555-5555. Saa za kufunguliwa ni:</br>\n\t\tJumatatu hadi Ijumaa kutoka 8:00 asubuhi hadi saa 12:00 jioni (Montreal)</br>\n\t\tNje ya masaa haya unaweza kuacha ujumbe na mtu atakayekujibu.',
    grievanceFollowUpAuthor: 'Mfumo',
    addFollowUpModalInfo: 'Tumia uga huu tu ikiwa unahitaji ufafanuzi au msaada kwa ombi lako',
    accessGrievanceTitle: 'Kufikia Malalamiko',
    grievanceRefNo: 'Nambari ya Malalamiko',
    accessGrievanceInfo: 'Tafadhali ingiza nambari yako ya malalamiko na nenosiri lako kufuatilia.',
    accessGrievanceBtn: 'Kufikia Malalamiko',
    viewGrievance: 'Ona Malalamiko',
    viewInitialGrievance: 'Ona Malalamiko ya Awali',
    originalGrievance: 'Malalamiko ya Awali',
    grievanceNumberPlaceholder: 'Ingiza nambari yako ya malalamiko...',
    grievanceDescriptionPlaceholder: 'Maelezo ya malalamiko...',
    detailsPlaceholder: 'Maelezo...',
    forgotPasswordGrievanceText:
        'Tafadhali ingiza nambari yako ya malalamiko pamoja na anwani ya barua pepe\n         ambayo ilitumiwa wakati wa uundaji. Ikiwa umefanya malalamiko yako kwa njia ya siri au haukuwasilisha anwani yako ya barua pepe, tafadhali wasiliana na huduma yetu ya wateja.',
    grievanceConfirmSuccessText: 'Malalamiko yako yamepokelewa kwa mafanikio.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Nenosiri lako limeundwa kwa mafanikio, kwa kufuata malalamiko yako, nenda kwa ukurasa wa uthibitisho',
    grievanceConfirmFollowUp: 'Fanya Ufuatiliaji wa Malalamiko',
    grievanceConfirmInfoText: 'Ikiwa unataka kufuata malalamiko uliyoyatuma, tafadhali unda nenosiri',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Mlalamikaji',
    emailNoteText: 'Barua pepe yako itatumika kutuma arifa za moja kwa moja lakini haitaonekana na mtu yeyote.',
};

const it: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        "Questo spazio dovrebbe contenere informazioni rilevanti per le parti interessate sull'uso del portale.",
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portale delle lamentele',
    homePageText:
        '<p>Benvenuti nel portale delle lamentele.</p>\n\t\t<p>Con questa piattaforma sicura e confidenziale, puoi inviarci le tue lamentele, richieste di informazioni o suggerimenti, in modo anonimo o meno. Successivamente, potrai monitorare la tua preoccupazione.</p>\n\t\t<p>Sia che tu scelga di inviare una lamentela in modo anonimo o meno, sii certo che ogni invio verrà trattato in modo confidenziale e tempestivo.</p>',
    createGrievanceTitle: 'Presentare una lamentela',
    createGrievanceText:
        'Inserisci i dettagli della tua lamentela. Sii il più preciso possibile. Se necessario, includi uno o più dei seguenti elementi: data, elementi importanti, luogo e persone coinvolte. Aggiungi foto se ne hai. Se desideri un follow-up, fornisci le tue informazioni nella sezione apposita.',
    footerText:
        'Se preferisci parlare con qualcuno, puoi chiamare il 819-555-5555. Gli orari sono:</br>\n\t\tLunedì-venerdì dalle 8:00 alle 17:00 ora locale (Montreal)</br>\n\t\tFuori da questi orari puoi lasciare un messaggio e qualcuno ti richiamerà.',
    grievanceFollowUpAuthor: 'Sistema',
    addFollowUpModalInfo: 'Utilizza questo campo solo se hai bisogno di chiarimenti o supporto per la tua richiesta',
    accessGrievanceTitle: 'Accedere a una lamentela',
    grievanceRefNo: 'Numero della lamentela',
    accessGrievanceInfo: 'Inserisci il numero della tua lamentela e la tua password per il follow-up.',
    accessGrievanceBtn: 'Accedere a una lamentela',
    viewGrievance: 'Visualizza la lamentela',
    viewInitialGrievance: 'Visualizza la lamentela iniziale',
    originalGrievance: 'Lamentela iniziale',
    grievanceNumberPlaceholder: 'Inserisci il numero della tua lamentela...',
    grievanceDescriptionPlaceholder: 'Dettagli della lamentela...',
    detailsPlaceholder: 'Dettagli...',
    forgotPasswordGrievanceText:
        "Inserisci il numero della tua lamentela e l'indirizzo email\n         utilizzato durante la creazione. Se hai creato la tua\n       lamentela in modo anonimo o non hai fornito il tuo indirizzo\n      email, contatta il nostro servizio clienti.",
    grievanceConfirmSuccessText: 'La tua lamentela è stata inviata con successo.',
    grievanceConfirmSubmitPasswordSuccessText:
        'La tua password è stata creata con successo, per dare seguito alla tua richiesta, vai alla pagina di verifica',
    grievanceConfirmFollowUp: 'Seguire una lamentela',
    grievanceConfirmInfoText: 'Se desideri dare seguito alla lamentela appena inviata, crea una password',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Richiedente',
    emailNoteText:
        'Il tuo indirizzo email verrà utilizzato per inviare notifiche automatiche ma non sarà visibile da nessuno.',
};

const sk: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Tento priestor by mal obsahovať relevantné informácie pre zúčastnené strany týkajúce sa používania portálu.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portál sťažností',
    homePageText:
        '<p>Vitajte na portáli sťažností.</p>\n\t\t<p>S touto bezpečnou a dôverne chránenou platformou môžete poslať svoju sťažnosť, požiadavku na informácie alebo návrh anonymne alebo nie. Následne budete môcť sledovať vašu obavu.</p>\n\t\t<p>Nech už sa rozhodnete poslať sťažnosť anonymne alebo nie, uistite sa, že každé podanie bude zaobstarané dôverne a v najkratšom možnom čase.</p>',
    createGrievanceTitle: 'Formulovať sťažnosť',
    createGrievanceText:
        'Prosím, zadajte podrobnosti vášho problému. Buďte čo najpresnejší. Ak je to potrebné, uveďte jednu alebo viac z nasledujúcich informácií: dátum, dôležité informácie, miesto a zapojené osoby. Ak chcete nasledovať, uveďte svoje kontaktné údaje v príslušnej sekcii.',
    footerText:
        'Ak by ste radšej hovorili s niekým, môžete zavolať na číslo 819-555-5555. Úradné hodiny sú:</br>\n\t\tPondelok až piatok od 8:00 do 17:00 východoeurópskeho času (Montreal)</br>\n\t\tMimo týchto hodín môžete zanechať správu a niekto vás kontaktuje.',
    grievanceFollowUpAuthor: 'Systém',
    addFollowUpModalInfo:
        'Použite toto pole iba v prípade, že potrebujete ďalšie objasnenia alebo podporu pre vašu žiadosť',
    accessGrievanceTitle: 'Prístup k sťažnosti',
    grievanceRefNo: 'Číslo sťažnosti',
    accessGrievanceInfo: 'Prosím, zadajte číslo vášho sťažnosti a heslo pre sledovanie.',
    accessGrievanceBtn: 'Prístup k sťažnosti',
    viewGrievance: 'Zobraziť sťažnosť',
    viewInitialGrievance: 'Zobraziť pôvodnú sťažnosť',
    originalGrievance: 'Pôvodná sťažnosť',
    grievanceNumberPlaceholder: 'Zadajte číslo svojej sťažnosti...',
    grievanceDescriptionPlaceholder: 'Detaily sťažnosti...',
    detailsPlaceholder: 'Detaily...',
    forgotPasswordGrievanceText:
        'Zadajte prosím číslo svojej sťažnosti a emailovú adresu,\n         ktorá bola použitá pri vytvorení. Ak ste vytvorili svoju\n       sťažnosť anonymne alebo ste nezadali svoju emailovú\n      adresu, kontaktujte náš zákaznícky servis.',
    grievanceConfirmSuccessText: 'Vaša sťažnosť bola úspešne odoslaná.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Vaše heslo bolo úspešne vytvorené, pre pokračovanie vo vašej žiadosti, prejdite na overovaciu stránku',
    grievanceConfirmFollowUp: 'Sledovať sťažnosť',
    grievanceConfirmInfoText: 'Ak chcete pokračovať vo sťažnosti, ktorú ste práve odoslali, vytvorte si heslo',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Žiadateľ',
    emailNoteText: 'Vaša e-mailová adresa bude použitá na odosielanie automatických oznámení, ale nikto ju neuvidí.',
};

const sq: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Kjo hapësirë duhet të përmbajë informacione relevante për palët interesante lidhur me përdorimin e portalit.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portali i ankesave',
    homePageText:
        '<p>Mirësevini në portalin e ankesave.</p>\n\t\t<p>Përmes kësaj platforme të sigurt dhe konfidenciale, mund të na dërgoni ankesën tuaj, kërkesën për informacion ose sugjerimin tuaj, në mënyrë anonime ose jo. Më pas mund të ndiqni shqetësimin tuaj.</p>\n\t\t<p>Nëse zgjidhni të dërgoni një ankesë në mënyrë anonime ose jo, sigurohuni që çdo dorëzim do të trajtohet me konfidencialitet dhe në kohën më të shkurtër të mundshme.</p>',
    createGrievanceTitle: 'Formulo një ankesë',
    createGrievanceText:
        'Ju lutemi, jepni detajet e ankesës suaj. Bëni sa më të saktë. Në qoftë se është e nevojshme, përfshini një ose më shumë nga të dhënat vijuese: data, informacione të rëndësishme, vendi dhe personat e përfshirë. Shtoni foto nëse keni. Nëse dëshironi të merrni një ndjekje, ju lutemi sigurohuni që të jepni të dhënat tuaja në seksionin e duhur.',
    footerText:
        "Nëse preferoni të flisni me dikë, mund të telefononi në 819-555-5555. Orët e hapjes janë:</br>\n\t\tE hënë deri të premten nga ora 8:00 deri në ora 17:00 sipas kohës lokale të Montrealit)</br>\n\t\tJashtë këtyre orëve mund të lini një mesazh dhe dikush do t'ju kontaktojë.",
    grievanceFollowUpAuthor: 'Sistemi',
    addFollowUpModalInfo: 'Përdorni këtë fushë vetëm nëse keni nevojë për sqarime ose mbështetje për kërkesën tuaj',
    accessGrievanceTitle: 'Aksesoni një ankesë',
    grievanceRefNo: 'Numri i ankesës',
    accessGrievanceInfo: 'Ju lutemi, jepni numrin tuaj të ankesës dhe fjalëkalimin për ndjekje.',
    accessGrievanceBtn: 'Aksesoni një ankesë',
    viewGrievance: 'Shiko ankesën',
    viewInitialGrievance: 'Shiko ankesën fillestare',
    originalGrievance: 'Ankesa fillestare',
    grievanceNumberPlaceholder: 'Jepni numrin tuaj të ankesës...',
    grievanceDescriptionPlaceholder: 'Përshkrimi i detajuar i ankesës...',
    detailsPlaceholder: 'Detajet...',
    forgotPasswordGrievanceText:
        'Ju lutemi, jepni numrin tuaj të ankesës dhe adresën tuaj email\n         që është përdorur gjatë krijimit. Në qoftë se keni krijuar ankesën tuaj në mënyrë anonime ose nuk keni dhënë adresën tuaj email,\n      ju lutemi kontaktoni shërbimin tonë ndaj klientëve.',
    grievanceConfirmSuccessText: 'Ankesa juaj u dërgua me sukses.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Fjalëkalimi juaj u krijua me sukses, për të vazhduar me kërkesën tuaj, shkoni te faqja e verifikimit',
    grievanceConfirmFollowUp: 'Ndjekni ankesën',
    grievanceConfirmInfoText: 'Nëse dëshironi të vazhdoni me ankesën që sapo dërguat, krijoni një fjalëkalim',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Klainti',
    emailNoteText:
        'Adresa juaj e emailit do të përdoret për të dërguar njoftimet automatike por nuk do të shihet nga askush.',
};

const nl: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Dit gebied moet relevante informatie bevatten voor belanghebbenden met betrekking tot het gebruik van het portaal.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Klachtenportaal',
    homePageText:
        '<p>Welkom bij het klachtenportaal.</p>\n\t\t<p>Met behulp van dit veilige en vertrouwelijke platform kunt u uw klacht, informatieverzoek of suggestie aan ons doorgeven, zowel anoniem als niet-anoniem. Vervolgens kunt u de voortgang van uw bezorgdheid volgen.</p>\n\t\t<p>Wees ervan verzekerd dat elke inzending, of u nu anoniem een klacht indient of niet, vertrouwelijk en tijdig zal worden behandeld.</p>',
    createGrievanceTitle: 'Een klacht indienen',
    createGrievanceText:
        'Voer de details van uw klacht in. Wees zo specifiek mogelijk. Voeg indien van toepassing de volgende elementen toe: datum, belangrijke items, locatie en betrokken personen. Voeg foto`s toe indien beschikbaar. Als u een follow-up wilt ontvangen, geef dan uw contactgegevens op in het juiste gedeelte.',
    footerText:
        'Als u liever met iemand spreekt, kunt u bellen naar 819-555-5555. De openingstijden zijn:</br>\n\t\tMaandag tot en met vrijdag van 8:00 tot 17:00 uur Eastern Time (Montreal)</br>\n\t\tBuiten deze uren kunt u een bericht achterlaten en wordt u teruggebeld.',
    grievanceFollowUpAuthor: 'Systeem',
    addFollowUpModalInfo: 'Gebruik dit veld alleen als u verduidelijking of ondersteuning nodig heeft voor uw verzoek',
    accessGrievanceTitle: 'Toegang tot een klacht',
    grievanceRefNo: 'Klachtnummer',
    accessGrievanceInfo: 'Voer uw klachtnummer en wachtwoord in om de voortgang te volgen.',
    accessGrievanceBtn: 'Toegang tot een klacht',
    viewGrievance: 'Bekijk de klacht',
    viewInitialGrievance: 'Bekijk de oorspronkelijke klacht',
    originalGrievance: 'Oorspronkelijke klacht',
    grievanceNumberPlaceholder: 'Voer uw klachtnummer in...',
    grievanceDescriptionPlaceholder: 'Details van de klacht...',
    detailsPlaceholder: 'Details...',
    forgotPasswordGrievanceText:
        'Voer uw klachtnummer in en het e-mailadres\n dat is gebruikt bij het aanmaken. Als u uw klacht anoniem heeft ingediend of uw e-mailadres niet heeft verstrekt,\n neem dan contact op met onze klantenservice.',
    grievanceConfirmSuccessText: 'Uw klacht is succesvol ingediend.',
    grievanceConfirmSubmitPasswordSuccessText:
        'Uw wachtwoord is succesvol aangemaakt, om uw verzoek verder te verwerken, ga naar de verificatiepagina',
    grievanceConfirmFollowUp: 'Volg de klacht op',
    grievanceConfirmInfoText:
        'Als u wilt doorgaan met de klacht die u zojuist hebt ingediend, maak dan een wachtwoord aan',
    grievanceRefNoFormat: 'GR-00000',
    claimant: 'Klager',
    emailNoteText:
        'Uw e-mailadres wordt gebruikt om automatische meldingen te verzenden maar zal door niemand worden gezien.',
};

const no: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText: 'Dette området bør inneholde relevant informasjon for interessentene om bruk av portalen.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal for klager',
    homePageText:
        '<p>Velkommen til klageportalen.</p><p>Via denne sikre og konfidensielle plattformen kan du sende oss din klage, forespørsel om informasjon eller forslag, anonymt eller ikke. Deretter kan du følge opp saken din.</p><p>Uansett om du velger å sende inn en klage anonymt eller ikke, kan du være trygg på at hver innsendelse behandles konfidensielt og raskt.</p>',
    createGrievanceTitle: 'Send inn en klage',
    createGrievanceText:
        'Vennligst oppgi detaljene om saken din. Vær så konkret som mulig. Oppgi i tilfelle: dato, sted, viktige detaljer og involverte personer. Legg ved bilder hvis du har. Hvis du ønsker oppfølging, vennligst oppgi kontaktinformasjonen din i riktig seksjon.',
    footerText:
        'Hvis du foretrekker å snakke med noen, kan du ringe oss på 819-555-5555. Åpningstidene er:<br/>Mandag–fredag 08:00–17:00, østlig tidssone (Montreal)<br/>Utenfor disse timene kan du legge igjen en melding, så kontakter noen deg.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo: 'Bruk dette feltet kun hvis du trenger avklaring eller støtte for forespørselen din',
    accessGrievanceBtn: 'Tilgang til en klage',
    accessGrievanceTitle: 'Tilgang til en klage',
    accessGrievanceInfo: 'Oppgi klagenummeret og passordet ditt for å følge opp saken.',
    grievanceRefNo: 'Klagenummer',
    originalGrievance: 'Opprinnelig klage',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Skriv inn klagenummeret ditt...',
    forgotPasswordGrievanceText:
        'Oppgi klagenummeret og e-postadressen\n        som ble brukt ved opprettelsen. Hvis du opprettet klagen\n        anonymt eller ikke oppga e-postadressen din,\n        vennligst kontakt kundeservicen vår.',
    grievanceDescriptionPlaceholder: 'Detaljer om klagen...',
    detailsPlaceholder: 'Detaljer...',
    grievanceConfirmSuccessText: 'Klagen din ble sendt inn.',
    grievanceConfirmInfoText: 'Hvis du vil følge opp klagen du nettopp sendte, opprett et passord',
    grievanceConfirmSubmitPasswordSuccessText:
        'Passordet ditt ble opprettet. For å følge opp klagen, gå til verifiseringssiden',
    grievanceConfirmFollowUp: 'Følg opp klagen',
    viewInitialGrievance: 'Se den opprinnelige klagen',
    viewGrievance: 'Se klagen',
    claimant: 'Søker',
    emailNoteText: 'E-postadressen din brukes til å sende automatiske varsler og vil ikke være synlig for andre.',
};

const pl: CustomLabelsState = {
    termsAndConditionsUrl: '',
    termsAndConditionsText:
        'Ta sekcja powinna zawierać istotne informacje dla interesariuszy dotyczące korzystania z portalu.',
    termsAndConditionsType: TermsAndConditionsType.TEXT,
    privacyPolicyUrl: '',
    portalTitle: 'Portal skarg i wniosków',
    homePageText:
        '<p>Witamy na portalu skarg i wniosków.</p><p>Za pomocą tej bezpiecznej i poufnej platformy możesz przesłać nam swoją skargę, prośbę o informacje lub sugestię, anonimowo lub nie. Następnie możesz śledzić status swojej sprawy.</p><p>Niezależnie od tego, czy zdecydujesz się złożyć skargę anonimowo czy nie, możesz być pewien, że każdy wniosek będzie traktowany poufnie i niezwłocznie.</p>',
    createGrievanceTitle: 'Złóż skargę lub wniosek',
    createGrievanceText:
        'Proszę podać szczegóły swojej sprawy. Bądź jak najbardziej konkretny. Jeśli dotyczy, podaj: datę, miejsce, ważne szczegóły oraz osoby zaangażowane. Dołącz zdjęcia, jeśli je posiadasz. Jeśli chcesz otrzymać informację zwrotną, podaj swoje dane kontaktowe w odpowiedniej sekcji.',
    footerText:
        'Jeśli wolisz porozmawiać z kimś z jakiegokolwiek powodu, możesz zadzwonić pod numer 819-555-5555. Godziny otwarcia:<br/>Poniedziałek–piątek 8:00–17:00, strefa czasowa wschodnia (Montreal)<br/>Poza tymi godzinami możesz zostawić wiadomość, a ktoś się z Tobą skontaktuje.',
    grievanceFollowUpAuthor: 'System',
    addFollowUpModalInfo:
        'Użyj tego pola tylko wtedy, gdy potrzebujesz wyjaśnienia lub wsparcia w sprawie swojego wniosku',
    accessGrievanceBtn: 'Dostęp do skargi lub wniosku',
    accessGrievanceTitle: 'Dostęp do skargi lub wniosku',
    accessGrievanceInfo: 'Wprowadź numer skargi lub wniosku oraz hasło, aby śledzić sprawę.',
    grievanceRefNo: 'Numer skargi lub wniosku',
    originalGrievance: 'Oryginalna skarga lub wniosek',
    grievanceRefNoFormat: 'GR-00000',
    grievanceNumberPlaceholder: 'Wprowadź numer skargi lub wniosku...',
    forgotPasswordGrievanceText:
        'Wprowadź numer skargi lub wniosku oraz adres e-mail\n        podany przy składaniu. Jeśli złożyłeś skargę lub wniosek\n        anonimowo lub nie podałeś adresu e-mail,\n        skontaktuj się z naszym działem obsługi klienta.',
    grievanceDescriptionPlaceholder: 'Szczegóły skargi lub wniosku...',
    detailsPlaceholder: 'Szczegóły...',
    grievanceConfirmSuccessText: 'Twoja skarga lub wniosek zostały pomyślnie przesłane.',
    grievanceConfirmInfoText: 'Jeśli chcesz śledzić skargę lub wniosek, które właśnie przesłałeś, utwórz hasło',
    grievanceConfirmSubmitPasswordSuccessText:
        'Hasło zostało pomyślnie utworzone. Aby śledzić skargę lub wniosek, przejdź do strony weryfikacji',
    grievanceConfirmFollowUp: 'Śledź skargę lub wniosek',
    viewInitialGrievance: 'Zobacz początkową skargę lub wniosek',
    viewGrievance: 'Zobacz skargę lub wniosek',
    claimant: 'Wnioskodawca',
    emailNoteText:
        'Twój adres e-mail będzie używany do wysyłania automatycznych powiadomień i nie będzie widoczny dla innych.',
};

const DefaultLabels = {
    en,
    fr,
    es,
    pt,
    ar,
    fi,
    sv,
    ja,
    de,
    ru,
    uz,
    el,
    it,
    nl,
    no,
    pl,
    sk,
    sw,
    sq,
};

export default DefaultLabels;
